import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, remove, scrollInfo } from 'kapix-components-vue3'
import hubExpertRessourcesPreparerRdvDecouverteStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'hubExpertRessourcesPreparerRdvDecouverte'
const customImplement: CustomStoreImplementationOptions = hubExpertRessourcesPreparerRdvDecouverteStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function hubExpertRessourcesPreparerRdvDecouverteFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('expert-ressource-1-rdv-decouverte.title', 'Préparer un rendez-vous découverte'),
        $description: $translate('expert-ressource-1-rdv-decouverte.description', 'À travers plusieurs conseils, Matchers vous donne les clés pour préparer votre premier rendez-vous découverte avec une entreprise.'),
        $publishedTime: new Date('2023-02-13T07:42:17.668Z'),
        $modifiedTime: new Date('2023-09-14T08:49:38.990Z'),
        // Constants,
        $constants: {
          question1Hidden: false,
          question1Hidden1: null,
          question2Hidden: false,
          question2Hidden1: null,
          question4Hidden: false,
          question4Hidden1: null,
          question3Hidden: false,
          question3Hidden1: null,
          question5Hidden: false,
          question5Hidden1: null,
          question6Hidden: false,
          question6Hidden1: null,
          k4EtapesTxtHidden: false,
          k4EtapesTxtHidden1: null,
          k6ConseilsTxtHidden: false,
          k6ConseilsTxtHidden1: null
        },
        // Data,
        $info: { expertRessource1RdvDecouverte: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async ltToutesLesRessourcesClick () {
        await navigateTo({ name: 'hub-expert-Ressources' })
      },
      /* @ts-ignore: to allow override in your custom file */
      etapesClick () { },
      /* @ts-ignore: to allow override in your custom file */
      deroulentClick () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      deroulentClickWhenSelected () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container7Click () {
        this.$elements['question-2'].style = { hidden: this.$constants.question2Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container7ClickWhenSelected () {
        this.$elements['question-2'].style = { hidden: this.$constants.question2Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container10Click () {
        this.$elements['question-4'].style = { hidden: this.$constants.question4Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container10ClickWhenSelected () {
        this.$elements['question-4'].style = { hidden: this.$constants.question4Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async commentRedigerUnClick () {
        await navigateTo({ name: 'hub-expert-Ressources-rediger-programme-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      container13Click () {
        this.$elements['question-3'].style = { hidden: this.$constants.question3Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container13ClickWhenSelected () {
        this.$elements['question-3'].style = { hidden: this.$constants.question3Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container16Click () {
        this.$elements['question-5'].style = { hidden: this.$constants.question5Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container16ClickWhenSelected () {
        this.$elements['question-5'].style = { hidden: this.$constants.question5Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container19Click () {
        this.$elements['question-6'].style = { hidden: this.$constants.question6Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container19ClickWhenSelected () {
        this.$elements['question-6'].style = { hidden: this.$constants.question6Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async text3Click () {
        await navigateTo({ hash: '#text-2--p44' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text4Click () {
        await navigateTo({ hash: '#k-4-etapes--p44' })
      },
      /* @ts-ignore: to allow override in your custom file */
      iconeDevUpClick () {
        this.$elements['k-4-etapes-txt'].style = { hidden: this.$constants.k4EtapesTxtHidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      iconeDevUpClickWhenSelected () {
        this.$elements['k-4-etapes-txt'].style = { hidden: this.$constants.k4EtapesTxtHidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async text5Click () {
        await navigateTo({ hash: '#k-6-conseils--p44' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text5ClickWhenSelected () {
        await navigateTo({ hash: '#k-6-conseils--p44' })
      },
      /* @ts-ignore: to allow override in your custom file */
      icon3Click () {
        this.$elements['k-6-conseils-txt'].style = { hidden: this.$constants.k6ConseilsTxtHidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      icon3ClickWhenSelected () {
        this.$elements['k-6-conseils-txt'].style = { hidden: this.$constants.k6ConseilsTxtHidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async ressource1Click () {
        await navigateTo({
          name: 'hub-expert-Ressources-rediger-programme-de-formation',
          hash: '#container-page--p45'
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      async container29Click () {
        await navigateTo({
          name: 'hub-expert-Ressources-construire-support-de-formation',
          hash: '#container-page--p46'
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      async container30Click () {
        await navigateTo({ name: 'Expert-Ressources-organiser-sa-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async container31Click () {
        await navigateTo({ name: 'Expert-Ressources-animer-la-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return hubExpertRessourcesPreparerRdvDecouverteFactory(storeId)()
}

export const hubExpertRessourcesPreparerRdvDecouverteRaw = hubExpertRessourcesPreparerRdvDecouverteFactory()
export const hubExpertRessourcesPreparerRdvDecouverte = () => hubExpertRessourcesPreparerRdvDecouverteRaw() as MergeCustomStore<typeof hubExpertRessourcesPreparerRdvDecouverteStoreCustom.instance>
